// // Accordion
// $(function() {
//     // ----------------------------
//     // ACCORDION
//     // ----------------------------
//     const accordion = (() => {
//         const toggleItem = function(data) {
//             if (window.innerWidth > 768) {
//                 return false;
//             }
//             let expanded = data.item.classList.contains('is-expanded');
//             if (expanded) {
//                 data.bodyWrap.style.height = 0;
//                 data.item.classList.add('not-expanded');
//                 data.item.classList.remove('is-expanded');
//             } else {
//                 data.bodyWrap.style.transform = 'matrix(1,0,0,1,0,0)';
//                 data.bodyWrap.style.height = data.itemHeight + 'px';
//                 data.item.classList.add('is-expanded');
//                 data.item.classList.remove('not-expanded');
//             }
//         };
//         const accordion = item => {
//             let bodyWrap = item.querySelector('.IconCards-back');
//             let itemHeight = bodyWrap.clientHeight;
//             bodyWrap.style.overflow = 'hidden';
//             bodyWrap.style.height = 0;
//             // toggleItem({ item, itemHeight, bodyWrap });
//             item.addEventListener('click', () =>
//                 toggleItem({
//                     item,
//                     itemHeight,
//                     bodyWrap
//                 })
//             );
//             // Not proud of this part
//             let hasbeenkilled = false;
//             // TODO: this is gross. find a way to build this into the core accordion class
//             $(window)
//                 .on('resize', function() {
//                     if (window.innerWidth > 768) {
//                         if (!hasbeenkilled) {
//                             _kill(item);
//                             hasbeenkilled = true;
//                         }
//                     } else {
//                         if (hasbeenkilled) {
//                             bodyWrap.style.overflow = 'hidden';
//                             bodyWrap.style.height = 0;
//                             hasbeenkilled = false;
//                         }
//                     }
//                 })
//                 .trigger('resize');
//         };
//         const _kill = item => {
//             let bodyWrap = item.querySelector('.IconCards-back');
//             bodyWrap.style.overflow = '';
//             bodyWrap.style.height = '';
//             bodyWrap.style.transform = '';
//             // item.classList.remove('is-expanded');
//             // item.classList.remove('not-expanded');
//         };
//         const init = () => {
//             let items = document.querySelectorAll('.IconCards-card');
//             let accordions = items.forEach(accordion);
//             return accordions;
//         };
//         return { init };
//     })();
//     accordion.init();
//     // -----------------
//     // Hacks
//     // let initialized = false;
//     // TODO: this is gross. find a way to build this into the core accordion class
//     // $(window)
//     //     .on('resize', function() {
//     //         if (window.innerWidth < 768) {
//     //             if (!initialized) {
//     //                 accordion.init();
//     //                 initialized = true;
//     //             }
//     //         } else {
//     //             if (initialized) {
//     //                 accordion.destroy();
//     //                 initialized = false;
//     //             }
//     //         }
//     //     })
//     //     .trigger('resize');
// });